import { render } from "./MiCard.vue?vue&type=template&id=89cf413c&scoped=true"
import script from "./MiCard.vue?vue&type=script&lang=js"
export * from "./MiCard.vue?vue&type=script&lang=js"

import "./MiCard.vue?vue&type=style&index=0&id=89cf413c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89cf413c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
